import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["adminInput", "memberInput", "moderatorIcon"];
  static values = {
    userId: String
  };

  connect() {
    this.updateIconVisibility();
  }

  toggleAdmin(event) {
    if (event) event.preventDefault();
    if (this.adminInputTarget.disabled) return;

    // Toggle checked state
    this.adminInputTarget.checked = !this.adminInputTarget.checked;
    
    // Update the icon
    this.updateIconVisibility();
    
    // Submit the form
    if (this.element.closest("form")) {
      this.element.closest("form").requestSubmit();
    }
  }

  removeMember(event) {
    if (event) event.preventDefault();
    
    // Remove the chip from the DOM (this also removes its hidden inputs)
    this.element.remove();
    
    // Update the member count label
    const countLabel = document.querySelector(".chat-room-dialog__selected-header .dialog__form--label");
    if (countLabel) {
      const remainingChips = document.querySelectorAll(".member-chips-wrap .member-chip");
      countLabel.textContent = `${remainingChips.length} Mitglieder`;
    }
  }

  updateIconVisibility() {
    if (this.hasModeratorIconTarget) {
      if (this.adminInputTarget.checked) {
        this.moderatorIconTarget.style.display = "inline";
      } else {
        this.moderatorIconTarget.style.display = "none";
      }
    }
  }
}
